import { IUser } from "./interfaces/IUser";

/**
 * @class UserModel
 * @description Datos básicos del usuario.
 * @implements {IUser}
 */
export default class UserModel implements IUser {
  id!: number;
  userName?: string | undefined;
  firstName!: string;
  lastName!: string;
  email!:string;
  photo!: string;

  constructor(user?:IUser){
    this.id = user?.id ?? 0;
    this.userName = user?.userName ?? "";
    this.firstName = user?.firstName ?? "";
    this.lastName = user?.lastName ?? "";
    this.email = user?.email ?? ""
    this.photo = user?.photo ?? "";
  }

  /**
   * @description Obtengo la concatenacion del nombre y el apellido del usuario.
   * @returns {string} [First Name] + [Last Name]
   */
  public getFullName(): string {
    return this.firstName !== "" && this.lastName !== "" ? `${this.firstName} ${this.lastName}` : "";
  }
}
